<template>
    <v-chip
      dense
      :small="!xSmall"
      :x-small="xSmall"
      class="status-chip"
      label
      :color="task.task_status_colour"
      >{{ task.task_status }}
    </v-chip>
</template>

<script>
import utils from "@/common/utils.js";

export default {
  name: "TaskStatus",
  props: {
    task: Object,
    xSmall: Boolean,
  },
  data: function () {
    return {
    };
  },
  components: {},
  watch: {},
  mounted() {},
  created() {},
  computed: {},
  methods: {},
};
</script>
<style>
</style>